// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3R3el","dragIcon":"Choice_dragIcon__2giw9","left":"Choice_left__2aG_m","input":"Choice_input__3CVzw"};